import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ZonesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfZoneWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfZoneWithPaginationDto,
  ZoneWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ZonesFormComponent } from "./zones-form/zones-form.component";
import { ZoneDirective } from './shared/zone.directive';


@Component({
    selector: 'app-zones',
    templateUrl: './zones.component.html',
    imports: [BaseIndexModule, ZonesFormComponent, ZoneDirective]
})
export class ZonesComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties

  pageName = PageNames.zones;
  modelWithPagination$: Observable<PaginatedListOfZoneWithPaginationDto>;
  items$: Observable<Array<ZoneWithPaginationDto>>;
  ZoneTypeEnumValues: GetEnumValuesDto[] = [];


    // Binding service endpoints
    protected currentService = inject(ZonesService);
    paginationApiMethodName: string = this.currentService.zonesGetZonesWithPagination.name;
    createGetApiMethodName: string = this.currentService.zonesCreateGet.name;
    deleteApiMethodName: string = this.currentService.zonesDelete.name;
    auditApiMethodName: string = this.currentService.zonesGetZonesAudit.name;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('ZoneType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.ZoneTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      { title: this.localizer.parent, name: 'ParentName', hasSearch: true },
      {
        title: `common.type`,
        name: 'type',
        hasSearch: true,
        type: 'enum',
        enumName: 'ZoneType',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .zonesUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
